import {
  createMockAppointment,
  getMockAppointment,
  getMockAppointments,
  updateMockAppointment,
} from './Appointment.mock'
import {
  answerMockAppointmentFollowUp,
  cancelMockAppointment,
  deleteMockAppointment,
  getMockAppointmentCancelPreview,
} from './Appointment.mock.followUp'

// TODO: call the CAL-02 §11 endpoints once the backend serves them; until then
// every call answers from the mock, and `mockContext` carries what the server
// knows itself (the caller, the anchors' names, the request's due date).
export function createAppointment({ data, mockContext }) {
  return createMockAppointment({ data, mockContext })
}

export function updateAppointment({ data, id, mockContext }) {
  return updateMockAppointment({ data, id, mockContext })
}

export function answerAppointmentFollowUp({ data, id }) {
  return answerMockAppointmentFollowUp({ data, id })
}

export function cancelAppointment({ data, id }) {
  return cancelMockAppointment({ data, id })
}

export function deleteAppointment({ data, id }) {
  return deleteMockAppointment({ data, id })
}

export function getAppointment({ historyOffset, id }) {
  return getMockAppointment({ historyOffset, id })
}

export function getAppointmentCancelPreview({ id }) {
  return getMockAppointmentCancelPreview({ id })
}

export function getAppointments({ params }) {
  return getMockAppointments({ params })
}
